<div class="idd-training-certificate-details-view-container" *ngIf="iddTrainingCertificateObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="id-info">
  </div>

  <div class="status-info">
  </div>

  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + iddTrainingCertificateObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="iddTrainingCertificateObject.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).meeting.write " (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>

  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" [fxFlex]="'100'" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Zaświadczenie</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail fxFlex="100" header="Rok" [value]="iddTrainingCertificateObject.iddTraining.year"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail fxFlex="100" header="Ofwca" [value]="iddTrainingCertificateObject.iddTraining.ofwca.fullName"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail fxFlex="100" header="TU" [value]="iddTrainingCertificateObject.insuranceCompany.name"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail fxFlex="100" header="Data szkolenia" [value]="iddTrainingCertificateObject.realisedAt | date:'y-MM-dd'"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="33">
                <app-detail fxFlex="100" header="Zrealizowano Majątek"
                            [value]="(floor(iddTrainingCertificateObject.realisedAssetsMinutes / 60) | number:'1.0-0') + 'h ' + (floor(iddTrainingCertificateObject.realisedAssetsMinutes % 60) | number:'1.0-0') + 'min'"></app-detail>
              </div>
              <div fxFlex="33">
                <app-detail fxFlex="100" header="Zrealizowano Życie"
                            [value]="(floor(iddTrainingCertificateObject.realisedLifeMinutes / 60) | number:'1.0-0') + 'h ' + (floor(iddTrainingCertificateObject.realisedLifeMinutes % 60) | number:'1.0-0') + 'min'"></app-detail>
              </div>
              <div fxFlex="33">
                <app-detail fxFlex="100" header="Zrealizowano Ogólne"
                            [value]="(floor(iddTrainingCertificateObject.realisedGeneralMinutes / 60) | number:'1.0-0') + 'h ' + (floor(iddTrainingCertificateObject.realisedGeneralMinutes % 60) | number:'1.0-0') + 'min'"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail fxFlex="100" header="Temat" [value]="iddTrainingCertificateObject.trainingTopic"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail-bool fxFlex="100" header="AML" [value]="iddTrainingCertificateObject.aml"></app-detail-bool>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <img
        class="certificate-overview"
        alt="Zaświadczenie"
        [src]="'/rest/crm/idd-training-certificate/' + iddTrainingCertificateObject.uuid + '/image'"
      />
    </div>

  </div>


</div>
